import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AbstractCRUD, CRUDService, ExceptionService, Searcher, UtilsService } from '../../xform-compat';
import { Permission } from '../../shared/models';
import { PermissionType } from '../../shared/models/permission-type.model';


@Injectable({
  providedIn: 'root'
})
export class PermissionService extends AbstractCRUD<PermissionType> implements CRUDService<PermissionType>, Searcher {

  constructor(
    exceptionService: ExceptionService,
    http: HttpClient,
    utilsService: UtilsService,
  ) {
    super(exceptionService, http, utilsService);
  }

  public getResourcePath(): string {
    return '/rms/permissions';
  }

  public getDisplayName(item: any): string {
    return item.name;
  }

}
